import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { VideoAnnotation, AnnotationCreateParams } from '@/types/videoAnnotations';
import { createAnnotation, deleteAnnotation } from '@/services/videoService';
import { rollReviewRepository } from '../repositories/supabaseRollReviewRepository';

export const useVideoAnnotations = (videoId: string | undefined) => {
  return useQuery({
    queryKey: ['video-annotations', videoId],
    queryFn: async (): Promise<VideoAnnotation[]> => {
      if (!videoId) throw new Error('No video ID');
      return rollReviewRepository.fetchVideoAnnotations(videoId);
    },
    enabled: !!videoId,
  });
};

export const useCreateAnnotation = (videoId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AnnotationCreateParams) => createAnnotation(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['video-annotations', videoId] });
    },
  });
};

export const useDeleteAnnotation = (videoId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (annotationId: string) => deleteAnnotation(annotationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['video-annotations', videoId] });
    },
  });
};
